<template>
  <div class="history-index" v-loading="loadingBtn">
    <!--  v-if="haveDate || loadingBtn" -->
    <el-row style="display:flex">
      <el-col :span="3" class="index-left">
        <div style="padding:10px 0px">
          <el-select v-model="selectCMP" placeholder="请选择账号(主体)" @change="changeCheck" clearable>
            <el-option v-for="item in companyList" :key="item.id"
              :label="item.text ? item.id + '(' + item.text + ')' : item.id" :value="item.id">
            </el-option>
          </el-select>
        </div>

        <div>
          <el-collapse v-model="activeNames" @change="hanleCollapse" accordion>
            <el-collapse-item v-for="(y, j) in years" :title="y + '年'" :name="y + ''" :key="j">
              <template slot="title">
                <div class="titleslot" @click="changeindex(j)" style="font-size:16px">
                  {{ y + '年' }}<i v-if="checkedindex == j" class="el-icon-caret-top"></i>
                  <i class="el-icon-caret-bottom" v-else></i>
                </div>
                <!-- 一致性 Consistency<i class="header-icon el-icon-info"></i> -->
              </template>
              <p v-for="(i, index) in month[y]" :key="index"
                style="min-height: 36px; line-height: 22px; cursor: pointer;padding:0 8px;">
                <span @click="handleActive(index, y, i)" :class="{ active_i: index == nowActive && y == nowActive2 }"
                  style="font-size:14px">{{ i.title }}
                  <span style="color:red" v-if="i.reservation">(预约中)</span></span>
              </p>
            </el-collapse-item>
          </el-collapse>
        </div>
      </el-col>
      <el-col :span="21" class="index-right">
        <el-row v-if="nowActive2 && title">
          <!-- 发送列表 -->
          <el-col :span="24" v-if="detailShow == 1">
            <!-- <h3 v-if="month.length">{{nowActive2+"-"+month[0][0]}}</h3>  -->
            <h3 style="  font-size: 22px;font-weight: 600;  color: rgba(44, 45, 58, 1); " v-show="nowActive2 && title">
              {{ nowActive2 + '-' + title }}
            </h3>
            <div class="sendinfo">
              <span v-if="sendInfo.sendTime">
                {{ reservation ? '预约' : '发送' }}时间：{{ $moment(sendInfo.sendTime).utc().tz('Asia/Shanghai')
                  .format('YYYY-MM-DD HH: mm:ss') || '' }}
              </span>
              <span v-else>
                发送时间：
              </span>
              <span>
                总人数：{{ sendInfo.totalNum }}人
              </span>
              <span>
                发送方式：{{ sendInfo.open ? "微信" : "" }}
                {{ sendInfo.open && (sendInfo.emailSend || sendInfo.smsSend) ? "、" : "" }}{{ sendInfo.emailSend ? "邮件" :
                  ""
                }}{{ sendInfo.smsSend && sendInfo.emailSend ? "、" : "" }}{{ sendInfo.smsSend ? "短信" : "" }}
              </span>
              <span class="Notice" style="cursor:auto;color:#838f99">
                签后即焚：{{ sendInfo.setInvalidReceipt ? '已开启' : '未开启' }}<span v-if="sendInfo.setInvalidReceipt">（{{
                  sendInfo.incinerateTime }}{{ sendInfo.incinerateType == "H" ? "小时" : (sendInfo.incinerateType == "D" ?
                    "天" :
                    "分钟")
                  }}）</span>
              </span>
              <span class="Notice" style="cursor:auto;color:#838f99">
                阅后即签：{{ sendInfo.openReaderSign ? '已开启' : '未开启' }}
              </span>
              <span class="Notice" @click="handleNotice">
                查看公告
              </span>

            </div>
            <el-row type="flex" class="search" justify="space-between">
              <!-- 切换搜索条件 -->
              <el-col :span="3" v-if="!reservation">
                <el-select v-model="value" placeholder="状态" @change="handleValChange">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="3" v-if="!reservation">
                <el-select v-model="signStatus" placeholder="签收" @change="handleSignStatusChange">
                  <el-option v-for="item in signOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="3" v-if="!reservation">
                <el-select v-model="signBackValue" placeholder="反馈" @change="handleSignBaclChange">
                  <el-option v-for="item in signBalck" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col :span="7">
                <el-input placeholder="请输入姓名/手机号/邮箱搜索" @keyup.enter.native="handleSerach" v-model="serachVal"
                  class="input-with-select">
                  <el-button slot="append" @click="handleSerach" icon="el-icon-search"></el-button>
                </el-input>
              </el-col>
              <el-col :span="3" v-if="reservation" style="text-align:right;">
                <el-button type="button" :loading="allLoading" :disabled="!tableData.length"
                  @click='cancelAll'>全部取消</el-button>
              </el-col>
              <el-col :span="7" v-if="!reservation">
                <el-dropdown style="float: right" class="dropdowns" trigger="click">
                  <el-button style="height:30px！important;">
                    <i class="iconfont icon-gengduo"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown" class="auth-index-dropdown">
                    <el-dropdown-item>
                      <p @click="handleBatch('del')">全部删除</p>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <p @click="handleBatch('recall')" v-if="userAuth.recall">
                        全部撤回
                      </p>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <p @click="handleBatch('resend')" v-if="userAuth.resend">
                        全部重发
                      </p>
                    </el-dropdown-item>
                    <el-dropdown-item>
                      <p @click="handleExport">全部导出</p>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <!-- <div>
                  <el-button
                    style="float: right; margin-right: 10px"
                    @click="handleExportcheck"
                    :loading="loadingBtn"
                    >选中导出</el-button
                  >
                  <el-button
                    style="float: right; margin-right: 10px"
                    @click="handleExport"
                    :loading="loadingBtn"
                    >全部导出</el-button
                  >
                </div> -->
              </el-col>
            </el-row>
            <el-row class='tables' style="margin-top:20px;">
              <el-table v-loading="loadingBtn" :data="tableData" style="width: 100%"
                :header-cell-style="{ background: 'rgba(59,196,146,0.1)' }" :cell-style="{ padding: 0 }"
                :row-style="{ height: 36 }" @selection-change="handleSelectionChange" ref="multipleTable">
                <el-table-column type="selection" align="center">
                </el-table-column>
                <el-table-column prop="name" label="姓名">
                  <template slot-scope="scope">
                    <span style="font-weight: 550;color:rgb(96, 98, 102)">
                      {{ scope.row.name }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column prop="mobile" label="手机号" min-width="130">
                  <template slot-scope="scope">
                    {{ scope.row.mobile == 'null' || scope.row.mobile == '' ? '无' : scope.row.mobile }}
                  </template>
                </el-table-column>
                <el-table-column prop="email" label="邮箱" min-width="220">
                  <template slot-scope="scope">
                    {{ scope.row.email == 'null' || scope.row.email == '' ? '无' : scope.row.email }}
                  </template></el-table-column>
                <el-table-column prop="read" label="状态" v-if="!reservation">
                  <template slot-scope="scope">
                    <span :class="[scope.row.read ? 'no_read' : 'is_read']">{{
                      scope.row.read ? '已读' : '未读'
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="签收" v-if="!reservation">
                  <template slot-scope="scope">
                    <span :class="[scope.row.signSuccess ? 'no_read' : 'is_read']">{{ scope.row.signSuccess ? '已签收' :
                      '未签收' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="反馈" v-if="!reservation">
                  <template slot-scope="scope">
                    <!-- scope.row.talkStatus -->
                    <span style="color: #909399" v-if="scope.row.talkStatus == 0" type="text">无</span>
                    <span style="color: #f56c6c" v-else-if="scope.row.talkStatus == 1" type="text">未处理</span>
                    <span style="color: #e6a23c" v-else-if="scope.row.talkStatus == 2" type="text">处理中</span>
                    <span style="color: #3bc492" v-else-if="scope.row.talkStatus == 3" type="text">已处理</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="250" align="center">
                  <template slot-scope="scope">
                    <div v-if="!reservation">
                      <el-button :style="'width:60px;color:#3A84FF'" type="text"
                        @click="handleTodetail(scope.row)">查看详情</el-button>
                      <el-button :style="'width:60px;text-align:center;margin-left:10px;color:#3A84FF'" type="text"
                        @click="hanleRecall(scope.row)" v-if="!scope.row.recall">撤回</el-button>
                      <el-button style="width:60px;text-align:center;color:#C0C4CC" type="text" v-if="scope.row.recall"
                        :disabled="true">已撤回</el-button>
                      <el-button
                        :style="`width:60px;margin-left:0;${!scope.row.recall ? 'color:#C0C4CC' : 'color:#3A84FF'}`"
                        type="text" @click="handleResend(scope.row)" :disabled="!scope.row.recall">重发</el-button>
                      <el-button style="width:40px;color:#3A84FF;margin-left:0" type="text"
                        @click="removeSelect(scope.row)">删除</el-button>
                    </div>
                    <div v-else>
                      <el-button style="width:60px;color:#3A84FF;margin-left:0" type="text"
                        @click="setCancelSending(scope.row)">取消预约</el-button>
                      <el-button :style="'width:60px;color:#3A84FF'" type="text"
                        @click="handleTodetail(scope.row)">查看详情</el-button>
                    </div>
                  </template>

                </el-table-column>
              </el-table>
              <div class="tablebottom">
                <div class="outbox" v-if="!reservation">
                  <el-checkbox v-model="checkall" @change="bottomcheck"></el-checkbox>
                  <button class="out" :style="outflag ? 'cursor: pointer' : 'cursor: not-allowed'"
                    @click="handleExportcheck">导出</button>
                  <button class="out" :style="!recallflag ? 'cursor: pointer' : 'cursor: not-allowed'"
                    @click="checkback" :disabled="recallflag">撤回 </button>
                  <button class="out" :style="Multiplelist.length > 0 ? 'cursor: pointer' : 'cursor: not-allowed'"
                    @click="removeSelect('')" :disabled="Multiplelist.length <= 0">删除 </button>
                </div>
                <div class="outbox" v-else>
                  <el-checkbox v-model="checkall" @change="bottomcheck"></el-checkbox>
                  <button class="out" :style="outflag ? 'cursor: pointer' : 'cursor: not-allowed'"
                    @click="setCancelSending('')">取消预约</button>
                </div>
                <div>
                  <el-pagination v-if="totalCount" small :current-page="tableRequest.pageNumber"
                    :page-size="tableRequest.size" layout="total,prev, pager, next" :total="totalCount"
                    @current-change="handleCurrentChange"></el-pagination>
                </div>
              </div>
            </el-row>
          </el-col>
          <!-- 查看详情 -->
          <template v-else-if="detailShow == 2">
            <el-col :span="12" style="margin-right:20px">
              <el-row>
                <el-row
                  style="width: 26px;height: 26px;background: #FFFFFF;border: 1px solid #E0E0E0;border-radius: 100%;text-align:center;cursor:pointer">
                  <i style="font-size: 12px;line-height:26px; font-weight: 500" @click="backHistory"
                    class="el-icon-arrow-left"></i>
                </el-row>
                <el-row class="row-72" type="flex" justify="space-between">
                  <!-- <input type="text"  v-model="copyeUrl">  -->
                  <el-tooltip :content="`${detailData.name}的工资条`" placement="bottom" effect="light">
                    <el-col :span="11" v-if="!reservation"
                      style=" font-size: 18px;font-family: PingFangSC-Semibold; font-weight: 600; color: rgba(44, 45, 58, 1); overflow: hidden;  display:flex;align-items:center;">
                      <span style="  text-overflow: ellipsis; white-space: nowrap;">
                        {{ detailData.name }}的工资条
                      </span>
                      <span :class="[detailData.read ? 'no_read_border' : 'is_read_border',]">
                        {{ detailData.read ? '已读' : '未读' }}
                      </span>
                    </el-col>
                    <el-col :span="24" v-else
                      style=" font-size: 20px;font-family: PingFangSC-Semibold; font-weight: 600; color: rgba(44, 45, 58, 1); ">
                      <span style="  text-overflow: ellipsis; white-space: nowrap;">
                        {{ detailData.name }}的工资条
                      </span>
                    </el-col>
                  </el-tooltip>
                  <el-col :span="13" style="z-index:999;min-width:260px">
                    <textarea id="input" style="display: none"></textarea>
                    <div class="back-btn"
                      :style="detailData.recall ? 'cursor:not-allowed;border: 1px solid rgba(0, 0, 0, 0.3);color: rgba(0, 0, 0, 0.3);' : 'cursor: pointer; border: 1px solid #ff6161;color: #ff6161;'"
                      v-if="!reservation && userAuth.recall" @click="hanleRecall(detailData)">撤回</div>
                    <div class="recall-btn" v-if="!reservation && userAuth.resend" @click="handleResend(detailData)"
                      :style="!detailData.recall ? 'cursor:not-allowed;border: 1px solid rgba(0, 0, 0, 0.3);color: rgba(0, 0, 0, 0.3);' : 'cursor: pointer; border: 1px solid #ff6161;color: #ff6161;'"
                      :disabled="!detailData.recall">重发</div>
                    <div class="copy-btn" v-if="!reservation && !detailData.recall" @click="hanleCopy(detailData)">复制链接
                    </div>
                  </el-col>
                </el-row>
                <!-- style="border-bottom: 1px solid rgba(224, 234, 241, 1)" -->
                <el-row class="row-40 detail-title" type="flex" justify="space-between">
                  <el-col class="title-text">工资条详情</el-col>
                  <div class="hover-i" @click="handleModify(detailData)" v-if="userAuth.recall">
                    {{ !reservation ? "重新编辑" : '编辑' }}
                  </div>
                </el-row>
                <template v-if="detailData.c">
                  <div class='tablebox ' style="">
                    <!-- 四种情况 -->
                    <!-- 1 -->
                    <el-row v-if="detailData.nullFlag && detailData.zeroFlag && i.value != '' && i.value != '0'"
                      v-for="(i, j) in changeAddEyesData" type="flex" :key="j" justify="space-between"
                      class="etail-info">
                      <el-col :span="1" style="line-height:26px;padding:10px 0; ">
                        <img class="111" v-show="!i.isShow" style="width:20px;position: relative;top:4px;"
                          src="./../assets/eye.png">
                      </el-col>
                      <el-col :span="8" style="line-height:26px;padding:10px 0; ">
                        {{ i.name.replace(/\\"/g, '"') }}
                      </el-col>
                      <el-col
                        style="text-align: right; padding:10px 0;font-weight: 400;word-wrap:break-word;line-height:26px;"
                        :span="15">
                        {{ i.value.replace(/\\"/g, '"') }}</el-col>
                    </el-row>


                    <!-- 2 ---99-->
                    <el-row v-if="!detailData.nullFlag && !detailData.zeroFlag" v-for="(i, j) in changeAddEyesData"
                      type="flex" :key="j" justify="space-between" class="etail-info">
                      <el-col :span="1" style="line-height:26px;padding:10px 0; ">
                        <img class="22222" v-show="!i.isShow" style="width:20px;position: relative;top:4px;"
                          src="./../assets/eye.png">
                      </el-col>
                      <el-col :span="8" style="line-height:26px;padding:10px 0; ">
                        {{ i.name.replace(/\\"/g, '"') }}
                      </el-col>
                      <el-col
                        style="text-align: right; padding:10px 0;font-weight: 400;word-wrap:break-word;line-height:26px;"
                        :span="15">
                        {{ i.value.replace(/\\"/g, '"') }}</el-col>
                    </el-row>


                    <!-- 3 -->
                    <el-row v-if="detailData.nullFlag && !detailData.zeroFlag && i.value != ''"
                      v-for="(i, j) in changeAddEyesData" type="flex" :key="j" justify="space-between"
                      class="etail-info">
                      <el-col :span="1" style="line-height:26px;padding:10px 0; ">
                        <img class="33333" v-show="!i.isShow" style="width:20px;position: relative;top:4px;"
                          src="./../assets/eye.png">
                      </el-col>
                      <el-col :span="8" style="line-height:26px;padding:10px 0; ">
                        {{ i.name.replace(/\\"/g, '"') }}
                      </el-col>
                      <el-col
                        style="text-align: right; padding:10px 0;font-weight: 400;word-wrap:break-word;line-height:26px;"
                        :span="15">
                        {{ i.value.replace(/\\"/g, '"') }}</el-col>
                    </el-row>
                    <!-- 4 -->
                    <el-row v-if="!detailData.nullFlag && detailData.zeroFlag && i.value != '0'"
                      v-for="(i, j) in changeAddEyesData" type="flex" :key="j" justify="space-between"
                      class="etail-info">
                      <el-col :span="1" style="line-height:26px;padding:10px 0; ">
                        <img class="44444" v-show="!i.isShow" style="width:20px;position: relative;top:4px;"
                          src="./../assets/eye.png">
                      </el-col>
                      <el-col :span="8" style="line-height:26px;padding:10px 0; ">
                        {{ i.name.replace(/\\"/g, '"') }}
                      </el-col>
                      <el-col
                        style="text-align: right; padding:10px 0;font-weight: 400;word-wrap:break-word;line-height:26px;"
                        :span="15">
                        {{ i.value.replace(/\\"/g, '"') }}</el-col>
                    </el-row>

                  </div>
                </template>
              </el-row>
              <!-- clickSign:true一键签收，false：手写签收  小程序一键签收signBase：画布没有传值，手写签收有传值 -->
              <el-row v-if="detailData.signBase || (detailData.clickSign && detailData.signSuccess)"
                style="border-bottom: 1px solid rgb(224, 234, 241)">
                <p style="line-height: 48px; font-size: 14px; font-weight: bold">
                  签名&nbsp;&nbsp;<span v-if="detailData.clickSign && detailData.signSuccess" style="color:#909399">签收于{{
                    $moment(detailData.signTime).format('YYYY/MM/DD HH:mm:ss') }}</span>
                </p>
                <div v-if="detailData.clickSign && detailData.signSuccess"
                  style="width: 50%;height: 51px;margin:0 auto;">
                  &nbsp;&nbsp;</div>
                <img v-if="detailData.signBase" style="display: block; margin: 0 auto; width: 50%"
                  :src="detailData.signBase" alt="" />
                <div class="signTime" style="text-align: right; font-size: 14px;line-height: 24px;">
                  签收于：{{ $moment(detailData.signTime).format('YYYY年MM月DD日 HH:mm:ss') }}
                </div>
              </el-row>

            </el-col>
            <el-col style="position: relative;padding-top:26px;width:47%">
              <div class="oktop">
                <el-button class="ok-btn" v-if="detailData.talkStatus !== 3" size="mini" round
                  @click="overFeedback">完成反馈</el-button>
              </div>
              <div class="history_title">
                <h4>员工反馈</h4>
                <!-- v-if="detailData.talkStatus==1 || detailData.talkStatus==2"  -->
              </div>
              <div class="talkbox">
                <div class="history_right">
                  <div class="history_content" ref="middle">
                    <el-empty v-if="historyList.length == 0" description="暂无反馈"></el-empty>
                    <div class="history_list" v-for="(item, index) in historyList" :key="index">
                      <div class="content_text" :class="{ contentType: item.from !== detailData.name }">
                        <div class="user_text">
                          <!-- <span>{{ item.from }}&nbsp;&nbsp;</span> -->
                          <span>{{
                            $moment(item.dateCreated).format('YYYY-MM-DD HH:mm')
                          }}</span>
                        </div>
                        <div class="content" :class="{ contentText: item.from !== detailData.name }">
                          {{ item.content }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="end_box" v-if="detailData.talkStatus !== 3">
                  <template>
                    <el-input resize='none' type="textarea" :rows="2" placeholder="请发送内容" v-model="sendContent">
                    </el-input>
                    <el-button type="success" style="margin-left: 10px;background: #3bc492;" :disabled="setContentType"
                      @click="sendSuint" size="mini">提交</el-button>
                  </template>
                </div>
              </div>

            </el-col>
          </template>
        </el-row>
        <el-row v-else style="text-align: center">
          <p style=" margin-top: 25px;  font-size: 20px; font-weight: 600; color: rgba(44, 45, 58, 1); "> 暂无数据 </p>
        </el-row>
      </el-col>
    </el-row>

    <el-dialog title="修改工资条" :visible.sync="modifyPassShow" width="800px" :close-on-click-modal="false">
      <el-form ref="modifyForm" :model="form" label-width="100px">
        <el-form-item v-for="(i, j) in modifyVal" :key="j" :label="j" :rules="[{ required: true, message: '选项不能为空' }]">
          <el-input :placeholder="`请输入新${j}`" v-model="modifyVal[j]"></el-input>
        </el-form-item>
      </el-form>
      <p style="padding-left: 120px" v-if="!this.reservation">
        <el-checkbox v-model="checked">保存后自动重发</el-checkbox>
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button type="danger" @click="modifyPassShow = false">取 消</el-button>
        <el-button @click="handleSubmit" :loading="loadingBtn">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="查看公告" :visible.sync="dialogVisible" @close="closeNotice" :close-on-click-modal="false"
      width="40%">
      <p style="line-height: 40px">
        公告内容
      </p>
      <el-input v-if="noticeDetail.length > 0" type="textarea" :rows="8" placeholder="在这里输入内容" maxlength="500"
        v-model="noticeDetail[0].content"></el-input>
      <el-input v-else type="textarea" :rows="8" disabled placeholder="暂无公告内容" maxlength="500"
        v-model="noticeNot"></el-input>
      <p style="margin-top: 20px">
      <p style="color: #3bc492"> 附件 </p>
      <p v-if="noticeDetail.length > 0">
        <a v-if="noticeDetail[0].uploadFiles.length > 0"
          :href="`${$http.defaults.baseURL}/salary-service/open/download?path=${noticeDetail[0].uploadFiles[0].url}`"
          :download="noticeDetail[0].uploadFiles[0].name">{{ noticeDetail[0].uploadFiles[0].name }}</a>
      <p v-else>暂无附件</p>
      </p>
      </p>
    </el-dialog>
  </div>
</template>

<script>
import { log } from "console";
import { SSL_OP_ALL } from "constants";
import { Form } from "element-ui";
import Cookie from "js-cookie";
import moment from "moment-timezone";
// import axios from 'axios'
import qs from "qs";

import {
  cancelSending,
  cancelSendingAll,
  checkback,
  checkExport,
  getcompanybyorgId,
  getsendRecordinfo,
  recordDelete,
  sendRecordExport,
  sendRecordPager,
  getcompanybyId
} from "@/api/setUp.js";

import bgImg from "../assets/history.png";
import http from "../utils/http";

export default {
  name: "index",
  components: {},
  data() {
    return {
      selectCMP: "",
      recallflag: true,
      timer: 0,
      sendContent: "",
      historyList: [],
      userAuth: {},
      copyeUrl: "",
      checked: true,
      loadingBtn: false,
      form: {},
      modifyPassShow: false,
      bgImg: bgImg,
      activeNames: "1",
      nowActive: 1,
      nowActive2: 1,
      title: "",
      year: "",
      serachVal: "",
      value: "",
      reservation: "",
      options: [
        {
          value: "全部",
          label: "全部",
        },
        {
          value: "已读",
          label: "已读",
        },
        {
          value: "未读",
          label: "未读",
        },
        {
          value: "已撤回",
          label: "已撤回",
        },
      ],
      signStatus: "",
      signBackValue: null,
      signOptions: [
        {
          value: "全部",
          label: "全部",
        },
        {
          value: "已签收",
          label: "已签收",
        },
        {
          value: "未签收",
          label: "未签收",
        },
      ],
      signBalck: [
        {
          value: "",
          label: "全部",
        },
        {
          value: 0,
          label: "无",
        },
        {
          value: 1,
          label: "未处理",
        },
        {
          value: 2,
          label: "处理中",
        },
        {
          value: 3,
          label: "已处理",
        },
      ],
      tableData: [],
      tableRequest: {
        pageNumber: 1,
        size: 10,
      },
      totalCount: 0,
      detailShow: 1, //1 记录列表 2查看详情  3编辑
      detailData: "",
      years: [],
      month: {},
      modifyVal: "",
      modifyId: "",
      sendTime: "",
      haveDate: false,
      Multiplelist: [],
      checkall: false,
      outflag: false,
      checkedindex: 0,
      sendInfo: [],
      firstOpen: null,
      changeAddEyesData: [],
      detailId: "",
      dialogVisible: false,
      noticeDetail: [],
      noticeNot: "",
      firstOpen: null,
      changeAddEyesData: [],
      detailId: "",
      showInput: false,
      allLoading: false,

      // 子公司搜索列表
      companyList: [],
    };
  },
  computed: {
    setContentType() {
      if (!this.sendContent) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    handleNotice() {
      this.dialogVisible = true;
    },
    closeNotice() {
      this.dialogVisible = false;
    },
    changeCheck(val) {
      console.log(this.selectCMP);
      this.getYears();
    },
    getUserInfo() {
      this.$http.get("authority-center/common/user/info").then(async (res) => {
        this.orgInfo = res.data;
        let { data } = await getcompanybyId(res.data.id);
        this.companyList = data;
      });
    },
    async setCancelSending(m) {
      let _params;
      if (m) {
        _params = { ids: m.id };
      } else {
        _params = { ids: this.Multiplelist.toString() };
      }
      if (!m && !this.Multiplelist.length) {
        return;
      }
      let { data } = await cancelSending(_params);
      if (data.code == 200) {
        this.$notify({
          title: "成功",
          message: data.msg,
          type: "success",
        });
        if (
          (m && this.totalCount - 1 > 0) ||
          (this.Multiplelist.length &&
            this.Multiplelist.length < this.totalCount)
        ) {
          this.getTableData();
        } else {
          this.getYears();
          this.getUserAuth();
          this.getUserInfo();
        }
        this.Multiplelist = [];
      } else {
        this.$notify({
          title: "失败",
          message: data.msg,
          type: "error",
        });
      }
    },
    // 全部取消
    async cancelAll() {
      this.allLoading = true;
      let { data } = await cancelSendingAll({
        ...this.tableRequest,
        deleted: true,
        title: this.title,
        pageNumber: undefined,
        size: undefined,
        verId: this.tableData[0].verId,
      });
      if (data.code == 200) {
        this.$notify({
          title: "成功",
          message: data.msg,
          type: "success",
        });
        this.getYears();
        this.getUserAuth();
        this.getUserInfo();
        this.allLoading = false;
      } else {
        this.$notify({
          title: "失败",
          message: data.msg,
          type: "error",
        });
        this.allLoading = false;
      }
    },
    async getsendInfo(m) {
      let { data } = await getsendRecordinfo({
        title: m || this.title,
        year: this.nowActive2,
      });
      this.sendInfo = data;
      // this.changeAddEyesData=[];
    },
    changeindex(val) {
      this.checkedindex = val;
    },
    bottomcheck(selectBottom) {
      selectBottom
        ? this.$refs.multipleTable.toggleAllSelection()
        : this.$refs.multipleTable.clearSelection();
      this.checkall = selectBottom;
    },
    async checkback() {
      const formData = new FormData();
      formData.append("id", this.Multiplelist.toString());
      let { data } = await checkback(formData);
      if (data.code == 200) {
        this.sendContent = "";
        this.$notify({
          title: "成功",
          message: "选择撤回成功",
          type: "success",
        });
        this.getTableData();
      } else {
        this.$notify({
          title: "失败",
          message: "选择撤回失败",
          type: "error",
        });
      }
    },
    handleSelectionChange(val) {
      if (val.length) {
        this.outflag = true;
      } else {
        this.outflag = false;
      }
      if (val.length == this.tableData.length) {
        this.checkall = true;
      } else {
        this.checkall = false;
      }
      this.Multiplelist = [];
      let flag = false;
      val.forEach((item) => {
        if (item.recall) {
          flag = true;
        }
        this.Multiplelist.push(item.id);
      });
      this.recallflag = flag;
      if (val.length == 0) {
        this.recallflag = true;
      }
    },
    backHistory() {
      this.detailShow = 1;
      clearInterval(this.timer);
    },
    // 完成反馈
    overFeedback() {
      // if(this.detailData.talkStatus == 1 || this.detailData.talkStatus == 2){
      this.$confirm("是否完成反馈？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      }).then(() => {
        this.$http
          .post(`salary-service/open/talk/${this.detailData.id}/close`)
          .then((res) => {
            if (res.data.code == 200) {
              this.sendContent = "";
              this.$notify({
                title: "成功",
                message: "反馈成功",
                type: "success",
              });
              this.detailShow = 1;
              clearInterval(this.timer);
              this.getTableData();
            }
          });
      });
      // }
    },
    // 提交员工反馈
    sendSuint() {
      // if(this.detailData.talkStatus == 1 || this.detailData.talkStatus == 2){
      this.$http
        .post("salary-service/open/replyTalk", {
          content: this.sendContent,
          sendRecordId: this.detailData.id,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.sendContent = "";
            this.$notify({
              title: "成功",
              message: "发送成功",
              type: "success",
            });
            this.setHistoryList();
          }
        });
      // }
    },
    async hanleCopy(val) {
      if (this.copyeUrl) {
        let input = document.querySelector("#input");
        input.innerText = this.copyeUrl;
        let clipboard = new ClipboardJS(".copy-btn", {
          text: () => this.copyeUrl,
        });
        clipboard.on("success", (e) => console.log(e.text));
        this.$message({
          type: "success",
          message: "复制成功",
        });
      } else {
        this.$message({
          type: "info",
          message: "复制失败",
        });
      }
    },
    handleBatch(type) {
      if (!this.tableData.length) {
        return;
      }
      switch (type) {
        case "del":
          let postData = {
            ...this.tableRequest,
            title: this.title,
            deleted: true,
            pageNumber: undefined,
            size: undefined,
            verId: this.tableData[0].verId,
          };
          this.$http
            .post("/salary-service/customer/send_Record/remove", postData)
            .then((res) => {
              this.$notify({
                title: "成功",
                message: "批量删除成功",
                type: "success",
              });
              this.getYears();
              this.getUserAuth();
              // this.getTableData()
              // this.nowActive=0;
              // this.handleActive(0,this.years[0],this.firstOpen[0])
            });
          break;
        case "recall":
          let postData2 = {
            ...this.tableRequest,
            allRecall: true,
            title: this.title,
            pageNumber: undefined,
            size: undefined,
            verId: this.tableData[0].verId,
          };
          this.$http
            .post(
              "/salary-service/customer/send_Record/batch_recall",
              postData2
            )
            .then((res) => {
              this.$notify({
                title: "成功",
                message: "批量撤回成功",
                type: "success",
              });
              this.getTableData();
            });
          break;
        case "resend":
          let postData3 = {
            ...this.tableRequest,
            allResend: true,
            title: this.title,
            pageNumber: undefined,
            size: undefined,
            verId: this.tableData[0].verId,
          };
          this.$http
            .post(
              "/salary-service/customer/send_Record/batch_resend",
              postData3
            )
            .then((res) => {
              if (res.data.code == 200) {
                this.$notify({
                  title: "成功",
                  message: "批量重发成功",
                  type: "success",
                });
                this.getTableData();
              } else {
                this.$notify({
                  title: "失败",
                  message: res.data.msg || "请先撤回后再重发",
                  type: "warning",
                });
              }
            });
          break;
      }
    },
    hanleCollapse(val) {
      console.log(val, "点击切换");
      if (!val) {
        this.checkedindex = -1;
      }
      if (val && !this.month[val]) {
        let _params;
        if (this.selectCMP) {
          _params = `salary-service/customer/title/${val}/customer?name=${this.selectCMP}`;
        } else {
          _params = `salary-service/customer/title/${val}/customer`;
        }
        // this.$http.get(`salary-service/customer/title/${val}/customer`).then((res) => {
        this.$http.get(`${_params}`).then((res) => {
          this.$set(this.month, val, res.data);
        });
      } else {
        return;
      }
    },
    async removeSelect(val) {
      const _params = this.Multiplelist.toString();
      let formData = new FormData();
      formData.append("ids", val ? val.id : _params);
      const { data } = await recordDelete(formData);
      if (data.code == 200) {
        this.getYears(1);
        this.$message({
          type: "success",
          message: "删除成功！",
        });
      }
    },

    async handleExportcheck() {
      if (this.outflag) {
        const formData = new FormData();
        formData.append("id", this.Multiplelist.toString());
        this.loadingBtn = true;
        this.tableRequest.talkStatus = this.signBackValue;
        const res = await checkExport(formData);
        let blob = new Blob([res.data], {
          type: "application/vnd.ms-excel", //将会被放入到blob中的数组内容的MIME类型
        });
        let url = URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "发送记录.xls";
        a.click();
        this.loadingBtn = false;
      }
    },
    async handleExport() {
      if (!this.tableData.length) {
        return;
      }
      this.loadingBtn = true;
      this.tableRequest.talkStatus = this.signBackValue;
      const res = await sendRecordExport({
        ...this.tableRequest,
        title: this.title,
        ...{
          pageNumber: undefined,
          size: undefined,
          verId: this.tableData[0].verId,
        },
      });

      let blob = new Blob([res.data], {
        type: "application/vnd.ms-excel", //将会被放入到blob中的数组内容的MIME类型
      });
      let url = URL.createObjectURL(blob);
      let a = document.createElement("a");
      a.href = url;
      a.download = "发送记录.xls";
      a.click();
      this.loadingBtn = false;
    },
    handleSubmit() {
      this.loadingBtn = true;
      this.$http
        .post("salary-service/customer/send_Record/updatePatch", {
          id: this.modifyId,
          content: JSON.stringify(this.modifyVal),
        })
        .then((res) => {
          if (this.checked) {
            this.$http
              .post("salary-service/customer/send_Record/resend", {
                id: this.modifyId,
                resend: true,
                recall: false,
              })
              .then((res) => {
                console.log(res);
                if (res.data.code == 200) {
                  this.$notify({
                    title: "成功",
                    message: "工资条重发成功",
                    type: "success",
                  });
                } else {
                  this.$notify({
                    title: "失败",
                    message: res.data.msg,
                    type: "error",
                  });
                }
                this.$http
                  .get(`salary-service/customer/send_Record/${this.modifyId}`)
                  .then((res) => {
                    this.detailData = res.data;
                    this.modifyPassShow = false;
                    this.loadingBtn = false;
                    this.getTableData(2);
                    // this.handleTodetail(res.data)
                  });
                this.$http
                  .get(`salary-service/customer/salary/url/${this.modifyId}`)
                  .then((response) => {
                    this.copyeUrl = response.data;
                  });
              });
          } else {
            this.$notify({
              title: "成功",
              message: "工资条保存成功",
              type: "success",
            });
            // 获取详情
            this.$http
              .get(`salary-service/customer/send_Record/${this.modifyId}`)
              .then((res) => {
                this.modifyPassShow = false;
                this.loadingBtn = false;
                this.detailData = res.data;
                this.getTableData(2);
                // this.handleTodetail(res.data)
              });
            this.$http
              .get(`salary-service/customer/salary/url/${this.modifyId}`)
              .then((response) => {
                this.copyeUrl = response.data;
              });
          }
        });
    },
    handleModify(val) {
      this.title = val.title;
      this.checked = val.reservation ? false : true;
      if (val.recall || this.reservation) {
        //是否撤回
        this.modifyPassShow = true;
        this.modifyVal = JSON.parse(val.c);
        this.modifyId = val.id;
      } else {
        this.$confirm(
          "将先撤回工资条，暂时阻止该员工查看，以免员工查看过期信息",
          "提示",
          {
            confirmButtonText: "撤回并继续",
            cancelButtonText: "取消",
            confirmButtonClass: "el-button--default",
            cancelButtonClass: "el-button el-button--danger",
            closeOnClickModal: false,
          }
        )
          .then(() => {
            let formdata = new FormData();
            formdata.append("id", val.id);
            formdata.append("recall", true);
            this.$http
              .post("salary-service/customer/send_Record/recall", formdata)
              .then((res) => {
                this.$http
                  .get(`salary-service/customer/send_Record/${val.id}`)
                  .then((res) => {
                    this.detailData = res.data;
                    this.modifyPassShow = true;
                    this.modifyVal = JSON.parse(val.c);
                    this.modifyId = val.id;
                    this.$notify({
                      title: "成功",
                      message: "工资条撤回成功",
                      type: "success",
                    });
                  });
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消撤回",
            });
          });
      }
    },
    async handleTodetail(val) {
      if (this.outflag) {
        this.$refs.multipleTable.clearSelection();
      }
      try {
        this.detailShow = 2;
        this.detailData = val;
        this.detailId = val.id;
        let _arr = [];
        console.log(val.c);
        let _json = JSON.parse(val.c);
        for (let key in _json) {
          _arr.push({ name: key, value: _json[key], isShow: true });
        }
        if (this.tableData[0].showContent) {
          let _filter = this.tableData[0].showContent.split(",");
          _filter.forEach((item) => {
            _arr.forEach((k) => {
              if (item == k.name) {
                k.isShow = false;
              }
            });
          });
        }
        console.log("999999", _arr);
        this.changeAddEyesData = _arr; //新增隐藏功能数据展示
        this.setHistoryList();
        this.timer = setInterval(() => {
          this.setHistoryList();
        }, 15000);
        if (!val.recall) {
          let url = await this.$http.get(
            `salary-service/customer/salary/url/${val.id}`
          );
          this.copyeUrl = url.data;
        }
      } catch (e) {
        console.log(e);
      }
    },

    async setHistoryList() {
      let res = await this.$http.get(
        `salary-service/open/talk/${this.detailData.id}`
      );
      this.historyList = res.data;
      this.$nextTick(() => {
        let middle = this.$refs["middle"];
        middle.scrollTop = middle.scrollHeight;
      });
    },
    handleValChange(val) {
      switch (val) {
        case "全部":
          this.tableRequest.year = this.year;
          this.tableRequest.title = this.title;
          this.tableRequest.send = true;
          this.tableRequest.read = undefined;
          this.tableRequest.recall = undefined;
          break;
        case "已读":
          this.tableRequest.year = this.year;
          this.tableRequest.title = this.title;
          this.tableRequest.send = true;
          this.tableRequest.read = true;
          this.tableRequest.recall = undefined;
          break;
        case "未读":
          this.tableRequest.year = this.year;
          this.tableRequest.title = this.title;
          this.tableRequest.send = true;
          this.tableRequest.read = false;
          this.tableRequest.recall = undefined;
          break;
        case "已撤回":
          this.tableRequest.year = this.year;
          this.tableRequest.title = this.title;
          this.tableRequest.send = true;
          this.tableRequest.read = undefined;
          this.tableRequest.recall = true;
          break;
      }
      this.handleCurrentChange(1);
    },
    handleSignStatusChange(val) {
      switch (val) {
        case "全部":
          this.tableRequest.year = this.year;
          this.tableRequest.title = this.title;
          this.tableRequest.sign = undefined;
          break;
        case "已签收":
          this.tableRequest.year = this.year;
          this.tableRequest.title = this.title;
          this.tableRequest.sign = true;
          break;
        case "未签收":
          this.tableRequest.year = this.year;
          this.tableRequest.title = this.title;
          this.tableRequest.sign = false;
          break;
      }
      this.handleCurrentChange(1);
    },
    handleSignBaclChange(val) {
      this.tableRequest.talkStatus = val;
      this.tableRequest.pageNumber = 1;
      this.getTableData();
    },
    handleActive(val, y, title) {
      // 切换搜索条件 read
      this.signStatus = "";
      this.signBackValue = null;
      this.value = "";
      this.serachVal = "";
      this.nowActive = val;
      this.nowActive2 = y;
      this.title = title.title;
      this.year = y;
      this.detailShow = 1;
      this.reservation = title.reservation;
      this.tableRequest = {
        pageNumber: 1,
        size: 10,
        year: y,
        title: title,
        send: true,
      };
      this.getTableData();
    },
    async getTableData(state) {
      // 1:控制双loading 2:控制眼睛展示的数据处理
      this.loadingBtn = state == 1 ? false : true;
      this.tableRequest.name = this.serachVal;
      delete this.tableRequest.title;
      const res = await sendRecordPager({
        ...this.tableRequest,
        title: this.title,
        ...{ pageNumber: this.tableRequest.pageNumber - 1 },
        companyName: this.selectCMP,
      });
      this.totalCount = +res.headers["x-total-count"];
      this.tableData = res.data;
      if (res.data.length != 0) {
        this.noticeDetail =
          res.data[0].sendNotice.length > 0 ? res.data[0].sendNotice : [];
      }
      if (state == 2) {
        this.handleTodetail(res.data[0]);
      }
      this.loadingBtn = false;
      if (this.tableData.length) {
        this.reservation = this.tableData[0].reservation;
      }
      this.getsendInfo();
    },
    async getYears() {
      this.years = [];
      this.month = [];
      this.tableData = [];
      this.sendInfo = [];
      this.title = "";
      this.loadingBtn = true;

      let res = await this.$http.get(
        `/salary-service/customer/getSendRecordYears?name=${this.selectCMP}`
      );
      if (res.data.data.length) {
        this.haveDate = true;
        this.years = res.data.data;
        this.activeNames = this.years[0];
        this.nowActive = 0;
        this.nowActive2 = this.activeNames;
        this.$http
          .get(
            `/salary-service/customer/title/${this.years[0]}/customer?name=${this.selectCMP}`
          )
          .then((res) => {
            this.$set(this.month, this.years[0], res.data);
            this.tableRequest.year = this.years[0];
            this.tableRequest.title = this.month[this.years[0]][0].title;
            this.tableRequest.send = true;
            this.title = this.month[this.years[0]][0].title;
            this.firstOpen = res.data;
            this.getTableData();
          });
        this.year = this.years[0];
      } else {
        console.log("没有年份");
        this.loadingBtn = false;
        this.haveDate = false;
      }
    },
    handleCurrentChange(val) {
      this.tableRequest.pageNumber = val;
      this.getTableData();
    },
    handleSerach() {
      if (this.serachVal) {
        this.handleCurrentChange(1);
      } else {
        delete this.tableRequest.name;
        this.handleCurrentChange(1);
      }
    },
    hanleRecall(val) {
      if (val.recall) {
        return;
      }
      this.$confirm("撤回后该员工无法查看工资条，确认撤回？", "提示", {
        confirmButtonText: "撤回",
        cancelButtonText: "取消",
        confirmButtonClass: "el-button--default",
        cancelButtonClass: "el-button el-button--danger",
        closeOnClickModal: false,
      })
        .then(() => {
          let formdata = new FormData();
          formdata.append("id", val.id);
          formdata.append("recall", true);
          this.$http
            .post("salary-service/customer/send_Record/recall", formdata)
            .then((res) => {
              this.$http
                .get(`salary-service/customer/send/record/${val.id}`)
                .then((res) => {
                  this.detailData = res.data;
                  this.$notify({
                    title: "成功",
                    message: "工资条撤回成功",
                    type: "success",
                  });
                  this.getTableData();
                });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消撤回",
          });
        });
    },
    handleResend(val) {
      if (!val.recall) {
        return;
      }
      this.$http
        .post("salary-service/customer/send_Record/resend", {
          id: val.id,
          resend: true,
          recall: false,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$http
              .get(`salary-service/customer/send_Record/${val.id}`)
              .then((res) => {
                this.detailData = res.data;
                this.$notify({
                  title: "成功",
                  message: "工资条重发成功",
                  type: "success",
                });
                this.$http
                  .get(`salary-service/customer/salary/url/${res.data.id}`)
                  .then((res) => {
                    this.copyeUrl = res.data;
                  });

                this.getTableData();
              });
          } else {
            this.$notify({
              title: "失败",
              message: res.data.msg,
              type: "error",
            });
          }
        });
    },
    async getUserAuth() {
      let res = await this.$http.get(
        `/salary-service/customer/getPackageServiceByCustomer`
      );
      this.userAuth = res.data;
    },
  },
  created() {
    this.loadingBtn = true;
  },
  mounted() {
    this.getYears();
    this.getUserAuth();
    this.getUserInfo();
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>

<style lang="less" scoped>
[v-cloak] {
  display: none;
}

.is_read {
  color: #ff6161;
}

.no_read {
  color: #3bc492;
}

.is_read_border {
  width: 44px;
  height: 24px;
  background: rgba(255, 97, 97, 0.1);
  border-radius: 4px;
  border: 1px solid #ff6161;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff6161;
  line-height: 24px;
  text-align: center;
  margin-left: 8px;
  // padding: 2px 4px;
}

.no_read_border {
  width: 44px;
  height: 24px;
  background: rgba(59, 196, 146, 0.1);
  border-radius: 4px;
  border: 1px solid #3bc492;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3bc492;
  line-height: 24px;
  text-align: center;
  margin-left: 8px;
}

.active_i {
  color: #3bc492;
}

.history-index {
  padding: 10px 10px 0 10px;
  background: #f7f7f8;
  // background: url('../assets/history.png') no-repeat 0px 45vh;
  background-size: 20%;

  .detail-info {
    font-size: 14px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(44, 45, 58, 1);
  }

  .detail-title {
    font-size: 16px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    color: rgba(131, 143, 153, 1);
    padding: 0 21px !important;
  }

  .index-left {
    width: 220px !important;
    height: calc(100vh - 63px - 18px);
    border-radius: 8px;
    margin-right: 10px;
    overflow-y: overlay;
    background: #fff;
    padding: 0 10px;
  }

  .index-right {
    background: #fff;
    padding: 15px;
    height: calc(100vh - 63px - 18px);
    overflow: auto;
    border-radius: 8px;
  }
}

.oktop {
  height: 55px;
  display: flex;
  justify-content: right;
  align-items: center;

  .ok-btn {
    width: 100px;
    height: 28px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #3bc492;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3bc492;
    line-height: 28px;
    text-align: center;
    padding: 0;
  }
}

.history_title {
  display: flex;
  height: 60px;
  justify-content: space-between;
  align-items: center;
  background: #f3f7f9;
  border-radius: 8px 8px 0px 0px;
  border: 1px solid #edf3f7;

  h4 {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #838f99;
    line-height: 22px;
    padding-left: 32px;
  }
}

.talkbox {
  border: 1px solid #edf3f7;
  padding: 0 22px;
  height: calc(100vh - 252px);
}

.history_right {
  font-size: 20px;

  .history_content {
    height: calc(55vh - 100px);
    background: #ffffff;
    border-radius: 8px;
    // border: 1px solid #edf3f7;
    padding: 10px;
    overflow-y: auto;

    .history_list {
      padding: 10px 0;

      .content_text {
        font-size: 16px;

        .content {
          display: inline-block;
          border: 1px solid #ccc;
          border-radius: 20px;
          padding: 0 15px;
          word-break: break-all;
          box-sizing: border-box;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 36px;
        }
      }

      .user_text {
        text-align: center;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #838f99;
        line-height: 14px;
        margin-bottom: 18px;
      }

      .contentText {
        padding: 0 15px;
        background: #3bc492;
        border-radius: 0px 6px 6px 6px;
        text-align: left;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 36px;
        word-break: break-all;
      }

      .contentType {
        text-align: right;
      }
    }
  }
}

.end_box {
  // border-top: 1px solid #ccc;
  padding: 10px 0;
  display: flex;
  align-items: center;

  // position: absolute;
  // left: 0;
  // bottom: 0;
}

.tablebottom {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.out {
  width: 83px;
  height: 36px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #e0eaf1;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #838f99;
  line-height: 36px;
  text-align: center;
  margin-left: 15px;
}

.out:hover {
  background: #ecf9f4;
  border: 1px solid #3bc492;
}

.outbox {
  display: flex;
  align-items: center;
  padding-left: 17px;
}

/deep/::-webkit-scrollbar {
  width: 0px !important;
}

/deep/.el-collapse-item__arrow {
  display: none;
}

/deep/.el-collapse-item__header {
  justify-content: space-between;
}

.titleslot {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

/deep/.el-pagination__total {
  font-size: 14px !important;
}

.copy-btn {
  float: right;
  margin-top: 16px;
  width: 100px;
  height: 28px;
  background: #3bc492;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
  user-select: none;
}

.recall-btn {
  float: right;
  // margin: 0 10px;
  margin-left: 10px;
  margin-top: 16px;
  width: 62px;
  height: 28px;
  background: #ffffff;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  // border: 1px solid rgba(0, 0, 0, 0.3);
  // color: rgba(0, 0, 0, 0.3);
  line-height: 28px;
  text-align: center;
  cursor: pointer;
  user-select: none;
}

.back-btn {
  float: right;
  margin-left: 10px;
  margin-top: 16px;
  width: 62px;
  height: 28px;
  background: #ffffff;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  // border: 1px solid #ff6161;
  // color: #ff6161;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
  user-select: none;
}

.row-40 {
  height: 60px !important;
  background: #f3f7f9;
  border-radius: 8px 8px 0px 0px;
  border: 1px solid #edf3f7;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 21px 0 30px;

  .title-text {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #838f99;
    line-height: 22px;
  }

  .hover-i {
    width: 100px;
    height: 28px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid #3bc492;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3bc492;
    line-height: 28px;
    cursor: pointer;
    text-align: center;
  }
}

.sendinfo {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #838f99;
  line-height: 20px;
  margin: 9px 0 16px 0;

  span {
    margin-right: 20px;
  }
}

/deep/.el-collapse-item__content {
  padding-bottom: 0 !important;
}

.tablebox {
  height: calc(100vh - 252px);
  overflow: auto;
  border: 1px solid #edf3f7;
}

.Notice {
  cursor: pointer;
  color: #3a84ff;
}

/deep/ .el-dialog {
  margin-top: 2vh !important;
}

/deep/ .el-table th.el-table__cell>.cell {
  font-weight: 600;
  color: rgb(144, 147, 153);
}

.content-right .index-right /deep/ .el-col .el-input__inner {
  // height:35px;
  // line-height: 35px;
}

/deep/ .dropdowns .el-button {
  padding: 5px 20px;
}

/deep/ .search .el-input__inner {
  height: 36px;
  line-height: 36px;
}

/deep/ .dropdowns .el-button {
  height: 36px !important;
}

/deep/ .el-input__suffix {
  height: 38px !important;
}

/deep/ .etail-info {
  border-bottom: 1px solid rgba(224, 234, 241, 1);
  min-height: 48px;
  line-height: 48px;
  font-size: 14px;
  font-weight: 400;
  padding: 0 23px;
}

/deep/ .tablebox:last-child {
  border-bottom: 0;
}

.row-72 {
  height: 54px !important;
  line-height: 54px !important;
}

/deep/ .el-empty {
  padding: 35px 0;
}
</style>
